
export default {
    name: 'DimOverlay',
    props: {
        isMobile: {
            type: Boolean,
            default: false,
        },
        tooltipToggle: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        tooltipToggle(newVal) {
            if (this.isMobile) {
                if (newVal) {
                    document.body.classList.add('pointer-events-none')
                } else {
                    document.body.classList.remove('pointer-events-none')
                }
            } else {
                document.body.classList.remove('pointer-events-none')
            }
        },
    },
}
